import {IStation} from '../api/api.types';

export interface IStationFormatter {
  (station:IStation):string;
}

const stationFormatterFactory = ():IStationFormatter => {
  return (station:IStation) => station &&
  `${station.siteCode} - ${station.siteName}`;
};
export default stationFormatterFactory;



/** WEBPACK FOOTER **
 ** ./app/meteostation/meteostation.formatter.ts
 **/